// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".friends-status-bar__button{position:fixed;z-index:201;top:5.5rem;right:0;background:#68d391;color:#fff;padding:.5rem;border-radius:5px 0 0 5px}", ""]);
// Exports
module.exports = exports;
